import { useTranslate } from '../../application/i18n/LocaleProvider';
import { InstallIcon } from '../icons/ControlIcons';

/**
 * The offer to keep the app.
 *
 * NON-BLOCKING BY CONSTRUCTION, and the constraint is structural rather than a
 * promise in a comment: it is a `<section>` in the document flow, not a
 * `<dialog>`. It has no backdrop, traps no focus, and cannot be the thing
 * between a reader and the garage. It asks from the bottom of a page they have
 * already scrolled through, which is the difference between an offer and an
 * interruption.
 *
 * The INSTRUCTION under the heading is the load-bearing part. Only Chromium
 * hands the page a prompt to fire; on iOS Safari, on desktop Safari and on
 * Firefox the primary action can do no more than repeat the sentence — so the
 * sentence has to be there, and hiding it behind the button would leave those
 * readers pressing a control that cannot install anything.
 */

/** Two claims, each of which is true — which is the only reason it is here. */
const BENEFIT_KEYS = [
    'pwa.install.benefit.fast',
    'pwa.install.benefit.offline',
];

export default function InstallOfferCard({ actionKey, howToKey, onInstall, onDismiss }) {
    const t = useTranslate();

    return (
        <section className="app-offer" aria-labelledby="install-offer-title">
            <span className="app-offer__mark" aria-hidden="true">
                <InstallIcon size={24} />
            </span>

            <h2 className="app-offer__title" id="install-offer-title">{t('pwa.install.title')}</h2>
            <p className="app-offer__body">{t('pwa.install.body')}</p>

            <ul className="app-offer__benefits">
                {BENEFIT_KEYS.map((benefitKey) => (
                    <li className="app-offer__benefit" key={benefitKey}>{t(benefitKey)}</li>
                ))}
            </ul>

            {howToKey ? <p className="app-offer__how">{t(howToKey)}</p> : null}

            <div className="app-offer__actions">
                {actionKey ? (
                    <button type="button" className="button button--primary" onClick={onInstall}>
                        {t(actionKey)}
                    </button>
                ) : null}
                <button type="button" className="app-offer__dismiss" onClick={onDismiss}>
                    {t('pwa.install.dismiss')}
                </button>
            </div>
        </section>
    );
}
